module.exports = __webpack_public_path__ + "static/media/op-house-icon.5d60eb0f.svg";